// extracted by mini-css-extract-plugin
export default {"title":"TaxonomyView_title__gXr5k","description":"TaxonomyView_description__Gdk1Z","categories":"TaxonomyView_categories__izYIA"};